// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.app-container[data-v-0650f0f4] .el-drawer__header {\n  margin-bottom: 10px;\n  border-bottom: 1px solid #cccccc;\n  padding-bottom: 20px;\n  color: black;\n}\n.table-active[data-v-0650f0f4] {\n  color: #00A551;\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
